import React, { useEffect } from 'react';
import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { useGlobalContext } from '../context';
import { useTranslation } from 'react-i18next'
import i18next from 'i18next';

function Navbar() {
    const { openSidebar, openContact, textEnter, buttonEnter, Leave, sectionRef} = useGlobalContext();

    const ref = useRef();
    useEffect(()=> {
        console.log(ref.current.innerText)
    },[])

    const { t } = useTranslation();
    function handleClick() {
        if(ref.current.innerText === "FR"){
            i18next.changeLanguage('fr')
        }
        else if(ref.current.innerText === "EN"){
            i18next.changeLanguage('en')
        }
    }

      const goToSection = (section) => {
        const selectedRef = sectionRef[section];
        if (selectedRef && selectedRef.current) {
          selectedRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }
      };


    return ( <section className="section navbar">
        <div className="container">
            <div className="navbar__container">
            <Link to="/" className='navbar__logo'><img src="https://res.cloudinary.com/dvvsyxugn/image/upload/v1704634044/logo_ql4mph.png" alt="DADY Consulting logo" /></Link>
            
            <div className="hide-for-mobile navbar__links_container">
                <div onMouseEnter={textEnter} 
                    onMouseLeave={Leave}
                    className="navbar__link_contaner">
                    <Link 
                    onClick={() => goToSection('about')}
                    className="navbar__link">
                        {t("nav.link1")}
                    </Link>
                </div>
                <div onMouseEnter={textEnter}
                    onMouseLeave={Leave} 
                    className="navbar__link_contaner">
                        <Link 
                            onClick={() => goToSection('expertise')}
                            className="navbar__link">
                                {t("nav.link2")}
                        </Link>
                </div>
                <div onMouseEnter={textEnter} onMouseLeave={Leave} className="navbar__link_contaner"><Link onClick={() => goToSection('team')} className="navbar__link">{t("nav.link3")}</Link></div>
                <div ref={ref} onMouseEnter={textEnter} onMouseLeave={Leave} className="navbar__link_contaner" onClick={()=>handleClick()}><Link to="#" className="navbar__link navbar__language">{t("nav.language")}</Link></div>
            </div>

            <Link className="hide-for-mobile cta">
                <button onMouseEnter={buttonEnter}
                    onMouseLeave={Leave}
                    className="cta__button"
                    onClick={() => openContact()}>
                        {t("nav.contact")}
                </button>
            </Link>
            <button 
            className="hide-for-desktop navbar__open_sidebar"
            onClick={() => openSidebar()}>
                <div className="navbar__open_sidebar_line"/>
                <div className="navbar__open_sidebar_line rotated"/>
            </button>
            
            </div>
            
        </div>
    </section> );
}

export default Navbar;